import { useMutation } from 'react-query';
import { UpdateDropBody } from './types';
import { checkDropAuth, client } from './droplrAuth';
import { omit } from 'lodash';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { TFunction } from 'i18next';

export const editDrop = async (body: UpdateDropBody) => {
  await checkDropAuth();

  return client.drops.update(body.dropId, omit(body, 'dropId'));
};

export const useEditDrops = (t: TFunction) => {
  return useMutation(async (bodies: UpdateDropBody[]) => {
    const results = await Promise.allSettled(
      bodies.map(body => editDrop(body))
    );

    const allSuccess = results.every(r => r.status === 'fulfilled');
    const someFailed = results.some(r => r.status === 'rejected');

    showUpdateToast(bodies, allSuccess, someFailed, t);

    return results;
  });
};

const showUpdateToast = (
  bodies: UpdateDropBody[],
  allSuccess: boolean,
  someFailed: boolean,
  t: TFunction
) => {
  if (someFailed) {
    errorToast({ title: t('Failed to update files') });
    return;
  }

  if (!allSuccess) return;

  const message = `${bodies.length === 1 ? t('File') : t('Files')} ${t('updated successfully')}`;

  successToast({ title: message });
};
